module.exports = __webpack_public_path__ + "images/deal-menu-bg.png";